import { render, staticRenderFns } from "./EmailMarketingPanel.vue?vue&type=template&id=968b76be&scoped=true"
import script from "./EmailMarketingPanel.vue?vue&type=script&lang=js"
export * from "./EmailMarketingPanel.vue?vue&type=script&lang=js"
import style0 from "./EmailMarketingPanel.vue?vue&type=style&index=0&id=968b76be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "968b76be",
  null
  
)

export default component.exports